module.exports = __webpack_public_path__ + "img/case-logo-2.a2c54401.png";